import React from 'react';
import { type MAccordionHeaderProps, MAccordionHeaderAlignment } from './MAccordionHeader.types';
import * as Styled from './MAccordionHeader.styles';
import { AHeader } from '../../atoms/AHeader/index';
import { type AHeaderProps, AHeaderSize } from '../../atoms/AHeader/AHeader.types';
import { ALinkStandalone } from '../../atoms/ALinkStandalone';
import { type ALinkStandaloneProps, ALinkStandaloneSize } from '../../atoms/ALinkStandalone/ALinkStandalone.types';
import clsx from 'clsx';

const COMPONENT_NAME = 'm-web-ui-kit-MAccordionHeader';
const TEST_ID = 'web-ui-kit-MAccordionHeader';

function MAccordionHeader({
  aHeader = {},
  aLinkStandalone = {},
  alignment = MAccordionHeaderAlignment.Left,
  link = false,
  ...rest
}: MAccordionHeaderProps) {
  const headerProps = {
    size: AHeaderSize.TitleS,
    ...aHeader,
    className: clsx(aHeader.className, 'm-accordion-header-title'),
  } as AHeaderProps;

  const linkProps = {
    size: ALinkStandaloneSize.Medium,
    ...aLinkStandalone,
    className: clsx(aLinkStandalone.className, 'm-accordion-header-toggle'),
  } as ALinkStandaloneProps;

  return (
    <Styled.Wrapper data-component-name={COMPONENT_NAME} data-testid={TEST_ID} alignment={alignment} {...rest}>
      {aHeader.text && <AHeader {...headerProps} />}
      {link && (aLinkStandalone.text || aLinkStandalone.children) && <ALinkStandalone {...linkProps} />}
    </Styled.Wrapper>
  );
}

export { MAccordionHeader, MAccordionHeaderAlignment, TEST_ID as M_ACCORDION_HEADER_TEST_ID };
export type { MAccordionHeaderProps };
